import {Injectable} from '@angular/core';
import {MsalService} from "@azure/msal-angular";
import {Router} from '@angular/router';
import {LoadingService} from '@core/services/loading.service';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  constructor(
    private readonly authService: MsalService,
    private readonly router: Router,
    private readonly loadingService: LoadingService
  ) {
    this.authService.instance.getAllAccounts();
  }

  async logout() {
    await this.authService.instance.initialize();

    this.authService.logoutRedirect().subscribe(() => {
      const itemKey = "msal.interaction.status";

      if (sessionStorage.getItem(itemKey)) {
        sessionStorage.removeItem(itemKey);
      }
      if (localStorage.getItem('ROLE')) {
        localStorage.removeItem('ROLE');
      }
      window.location.reload();
    });
  }

  async unauthorized() {
    this.loadingService.hide();
    await this.router.navigate(['/']);
  }
}
